<template>
  <div ref="wrapper" class="grid-container full container" :class="{displayBottomBorder: displayBottomBorder}">
    <div class="grid-x" >

      <div class='carousel-view'>
        <transition-group
          name='carousel'
          class='carousel'
          tag="div">
          <div
            v-for="slide in slides"
            class='slide'
            :key="slide.id">

            <div @click="openLink(slide.link)" :class="slide.link && 'isLink'"  class="grid-container" style="width: 100% !important; ">
              <div class="grid-x">

                <div class=" small-12 medium-10 cell">
                  <h2 v-if="slide.title">{{ slide.title }}</h2>
                  <p :style="!slide.title ? 'margin-top: 60px;' : null" v-html="slide.text"></p>
                </div>

                <div class=" small-12 medium-2 cell text-center ">
                  <img
                    :class='slide.imageClass'
                    :src='slide.image'
                    :alt='slide.altText' />
                </div>
              </div>
            </div>

          </div>
        </transition-group>
      </div>


    </div>
  </div>
</template>

<script>

import UKBTA from '@/assets/img/ticker/ukbta.png';
import TheEscape100 from '@/assets/img/ticker/TheEscape100.png';
import TheEscape1002021 from '@/assets/img/ticker/TheEscape100-2021.png';
import FinancialTimesLogo from '@/assets/img/ticker/financial-times-logo.png';
import RecruiterAwardsLogo from '@/assets/img/ticker/recruiter-awards_Official-logos-2020-winner.png';
import LegalWeekLogo from '@/assets/img/ticker/LegalWeek.png';

export default {
  name: 'RareAwardsSection',
  props: {
    displayBottomBorder: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      intervalid1: '',
      title: null,
      text: null,
      image: null,
      isInView: false,
      // NOTE: YOU NEED AN ODD NUMBER OF SLIDES FOR THEM TO DISPLAY PROPERLY.
      slides: [
        {
          title: '',
          link: null,
          text: '“A tool so simple and efficient it is hard to think of a reason why every leading business should not sign up.”',
          image: LegalWeekLogo,
          altText: 'Contextual Recruitment Award Winner',
          imageClass: 'legalweek',
          id: 1,
        },
        {
          title: 'WINNER',
          link: 'https://www.escapethecity.org/organisation/rare-recruitment',
          text: 'ESCAPE THE CITY - TOP 100 COMPANIES TO ESCAPE TO IN 2023',
          image: TheEscape100,
          altText: 'Top 100 companies to escape to in 2023',
          imageClass: 'escape100',
          id: 2,
        },
        {
          title: '',
          link: null,
          text: '“Highly evidence-based with huge positive impact.”<br/>Judging Panel, Recruiter Awards 2020 ',
          image: RecruiterAwardsLogo,
          altText: 'Diversity Innovator Award Winner',
          imageClass: 'rmbcc',
          id: 3,
        },
        {
          title: 'WINNER',
          link: null,
          text: 'Recruiter Magazine Best Candidate Care 2020',
          image: RecruiterAwardsLogo,
          altText: 'Recruiter Magazine Best Candidate Care 2020',
          imageClass: 'rmbcc',
          id: 4,
        },
        {
          title: 'WINNER',
          link: 'https://www.escapethecity.org/organisation/rare-recruitment',
          text: 'ESCAPE THE CITY - TOP 100 COMPANIES TO ESCAPE TO IN 2021',
          image: TheEscape1002021,
          altText: 'Top 100 companies to escape to in 2021',
          imageClass: 'escape100-2021',
          id: 5,
        },
        {
          title: '',
          link: null,
          text: '"Class warriors turn to tech for results."',
          image: FinancialTimesLogo,
          altText: 'Social Mobility Award Winner',
          imageClass: 'ft',
          id: 6,
        },
        {
          title: 'WINNER',
          link: 'https://businesstechawards.com/2024-winners/',
          text: 'UK Business Tech Awards 2024 - Tech For Good Award',
          image: UKBTA,
          altText: 'UK Business Tech Awards 2024 - Tech For Good Award',
          imageClass: 'ukbta',
          id: 7,
        },
        {
          title: 'WINNER',
          link: 'https://businesstechawards.com/2024-winners/',
          text: 'UK Business Tech Awards 2024 – Best Application of Tech in the Public Sector Award',
          image: UKBTA,
          altText: 'UK Business Tech Awards 2024 – Best Application of Tech in the Public Sector Award',
          imageClass: 'ukbta',
          id: 8,
        },
        {
          title: 'WINNER',
          link: 'https://www.escapethecity.org/organisation/rare-recruitment',
          text: 'ESCAPE THE CITY - TOP 100 COMPANIES TO ESCAPE TO IN 2023',
          image: TheEscape100,
          altText: 'Top 100 companies to escape to in 2023',
          imageClass: 'escape100',
          id: 9,
        },
        {
          title: '',
          link: null,
          text: '“Highly evidence-based with huge positive impact.”<br/>Judging Panel, Recruiter Awards 2020 ',
          image: RecruiterAwardsLogo,
          altText: 'Diversity Innovator Award Winner',
          imageClass: 'rmbcc',
          id: 10,
        },
        {
          title: 'WINNER',
          link: null,
          text: 'Recruiter Magazine Best Candidate Care 2020',
          image: RecruiterAwardsLogo,
          altText: 'Recruiter Magazine Best Candidate Care 2020',
          imageClass: 'rmbcc',
          id: 11,
        },
        {
          title: 'WINNER',
          link: 'https://www.escapethecity.org/organisation/rare-recruitment',
          text: 'ESCAPE THE CITY - TOP 100 COMPANIES TO ESCAPE TO IN 2021',
          image: TheEscape1002021,
          altText: 'Top 100 companies to escape to in 2021',
          imageClass: 'escape100-2021',
          id: 12,
        },
        {
          title: '',
          link: null,
          text: '"Class warriors turn to tech for results."',
          image: FinancialTimesLogo,
          altText: 'Social Mobility Award Winner',
          imageClass: 'ft',
          id: 13,
        },
      ],
    };
  },

  methods: {
    next() {
      const first = this.slides.shift();
      this.slides = this.slides.concat(first);
    },

    openLink(link) {
      if (link) window.open(link);
    },
    isVisibleInViewport(element) {
      const rect = element.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    },
    handleScroll() {
      const newState = this.isVisibleInViewport(this.$refs.wrapper);
      const oldState = this.isInView;

      if (oldState === false && newState === true) {
        this.startTimer();
        this.isInView = true;
      }

      if (oldState === true && newState === false) {
        this.stopTimer();
        this.isInView = false;
      }
    },
    startTimer() {
      this.intervalid1 = setInterval(() => {
        this.next();
      }, 4000);
    },
    stopTimer() {
      clearInterval(this.intervalid1);
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    clearInterval(this.intervalid1);
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .container {
  }

  .displayBottomBorder {
    border-bottom: 1px solid $border;
  }

  .isLink {
   cursor: pointer;
 }

  h2 {
    color: $green-highlight;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-transform: uppercase;
  }

  p {
    color: $main-text;
    font-weight: 700;
    font-style: normal;
    font-stretch: normal;
    text-transform: uppercase;
  }

  .carousel-view {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }

  .carousel {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    overflow: hidden;
  }

  .slide {
    transform: translateZ(0) scale(1.0, 1.0);
    display: flex;
    justify-content: left;
    align-items: flex-start;
    overflow: hidden;
    transition: transform 0.3s ease-in-out;
  }

  .slide:first-of-type, .slide:last-of-type {
    opacity: 0 !important;
  }

  .slide:nth-of-type(3) {
    opacity: 1 !important;
  }


  @media only screen and (max-width: 640px)  {

    .carousel-view {
      height: 280px;
      margin-bottom: 48px;
    }

    .carousel {
      min-height: 280px;
    }

    .slide {
      flex: 0 0 26em;
    }

    h2 {
      font-size: 21px;
      line-height: 1.11;
      margin-bottom: 15px;
      margin-top: 55px;
      text-align: center;
    }

    p {
      font-size: 16px;
      line-height: 1.67;
      margin-bottom: 0;
      text-align: center;
    }

    .ukbta {
      height: 55px;
      width: auto;
      margin: 20px auto 0 auto;
    }

    .cipd {
      height: 45px;
      width: auto;
      margin: 20px auto 0 auto;
    }
    .escape100 {
      height: 60px;
      width: auto;
      margin: 20px auto 0 auto;
    }
    .ft {
      height: 60px;
      width: auto;
      margin: 20px auto 0 auto;
    }
    .legalweek {
      height: 31px;
      width: auto;
      margin: 20px auto 0 auto;
    }
    .opportunity {
      height: 100px;
      width: auto;
      margin: 20px auto 0 auto;
    }
    .legalweek17 {
      height: 60px;
      width: auto;
      margin: 20px auto 0 auto;
    }
    .gamechanger16 {
      height: 100px;
      width: auto;
      margin: 20px auto 0 auto;
    }
    .race {
      height: 100px;
      width: auto;
      margin: 20px auto 0 auto;
    }
    .rmbcc {
      height: 90px;
      width: auto;
      margin: 20px auto 0 auto;
    }
  }

  @media only screen and (min-width: 641px) and (max-width: 1200px)  {
    .slide {
      flex: 0 0 100em;
      width: 100%;
    }

  }

  @media only screen and (min-width: 1201px) {
    .slide {
      flex: 0 0 auto;
      margin: 0 5% 0 5%;
      width: 100%;
    }
  }

  @media only screen and (min-width: 641px)  {

    .carousel-view {
      height: 229px;
    }

    .carousel {
      min-height: 229px;
    }

    h2 {
      font-weight: 700;
      font-size: 34px;
      letter-spacing: 0.1em;
      line-height: 40px;
      margin-bottom: 0;
      margin-top: 75px;
      text-align: left;
    }

    p {
      font-size: 24px;
      font-weight: 700;
      line-height: 40px;
      letter-spacing: 0.1em;
      margin-bottom: 65px;
      text-align: left;
    }

    .awardsImg {
      display: inline-block;
      float: right;
      margin-top: 55px;
      max-width: 110px;
    }

    .ukbta {
      height: 85px;
      width: auto;
      margin-top: 50%;
      float: right;
    }
    .cipd {
      height: 60px;
      width: auto;
      margin-top: 50%;
      float: right;
    }
    .escape100 {
      height: 75px;
      width: auto;
      margin-top: 40%;
      float: right;
    }
    .escape100-2021 {
      height: 90px;
      width: auto;
      margin-top: 40%;
      float: right;
    }
    .ft {
      height: 60px;
      width: auto;
      margin-top: 33%;
      float: right;
    }
    .legalweek {
      height: 31px;
      width: auto;
      margin-top: 50%;
      float: right;
    }
    .opportunity {
      height: 100px;
      width: auto;
      margin-top: 30%;
      float: right;
    }
    .legalweek17 {
      height: 60px;
      width: auto;
      margin-top: 45%;
      float: right;
    }
    .gamechanger16 {
      height: 100px;
      width: auto;
      margin-top: 30%;
      float: right;
    }
    .race {
      height: 100px;
      width: auto;
      margin-top: 30%;
      float: right;
    }
    .rmbcc {
      height: 100px;
      width: auto;
      margin-top: 30%;
      float: right;
    }
  }


  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {


    .carousel {
      height: 250px;
      min-height: 250px;
      width: 100%;
    }

    .slide {
      //flex: 0 0 30em;
      width: 100%;
    }


    .carousel-view {
      height: 280px;
      width: 100%;
    }


    .slide {
      display: none;
      overflow: visible;
      width: 100%;
      transition: none;
    }

    .slide:nth-of-type(3) {
      display: block !important;
      opacity: 1 !important;
      text-align: center;
      margin: 0 0 0 0;
    }

    .slide:nth-of-type(3) span {
      opacity: 1 !important;
      border-bottom: 5px solid $green-highlight;
      text-align: center;
    }

    .ft {
      height: 60px;
      width: auto;
      margin: 60px auto 0 auto;
    }
    .legalweek {
      height: 31px;
      width: auto;
      margin: 100px auto 0 auto;
    }
    .opportunity {
      height: 100px;
      width: auto;
      margin: 70px auto 0 auto;
    }
    .legalweek17 {
      height: 60px;
      width: auto;
      margin: 100px auto 0 auto;
    }
    .gamechanger16 {
      height: 100px;
      width: auto;
      margin: 80px auto 0 auto;
    }
    .race {
      height: 100px;
      width: auto;
      margin: 70px auto 0 auto;
    }
    .rmbcc {
      height: 100px;
      width: auto;
      margin: 70px auto 0 auto;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/carousels/awardsCarousel.vue